import React from 'react';
import { ITab } from './interfaces';
import { Tab as TabMui } from '@mui/material';

export const Tab: React.FC<ITab> = ({ label, ...other }): JSX.Element => {
  return (
    <TabMui
      label={label}
      iconPosition="start"
      {...other}
      sx={{
        textTransform: 'none',
        fontWeight: 'bold',
        padding: '13px',
        margin: 0,
        minHeight: 32,
      }}
    />
  );
};
